import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';

import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';

import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { MessagesModule } from 'primeng/messages';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsComponent } from './list/reports-list.component';
import { ReportsDetailComponent } from './detail/reports-detail.component';
import { AccordionModule } from 'primeng/accordion';
import { FieldsetModule } from 'primeng/fieldset';
import { ReportsVisualizationComponent } from './visualization/reports-visualization.component';
import { ReportsUsersGroupsPermissionsComponent } from './detail/reports-users-groups-permissions/reports-users-groups-permissions.component';
import { ReportsUsersGroupsPermissionsListComponent } from './detail/reports-users-groups-permissions-list/reports-users-groups-permissions-list.component';


import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        ReportsComponent,
        ReportsDetailComponent,
        ReportsVisualizationComponent,
        ReportsUsersGroupsPermissionsComponent,
        ReportsUsersGroupsPermissionsListComponent
    ], imports: [CoreModule,
        ReportsRoutingModule,
        BrowserModule,
        FormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputSwitchModule,
        DropdownModule,
        ConfirmDialogModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        DropdownModule,
        DialogModule,
        EditorModule,
        ReactiveFormsModule,
        FileUploadModule,
        MultiSelectModule,
        AccordionModule,
        FieldsetModule,
        MessagesModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ReportsModule { }
